import { useState } from 'react';

import {
  pastedReceivingWalletAddressSelector,
  useMarketTradeSettingsStore,
} from '@/store/tradeSettings/market';

import { fontStyles } from '@/styles/typography';

import { EditIcon } from '@/ui/Icons/EditIcon';

import { formatShortAddress } from '@/utils/address';

import { PasteOrConnectWalletModal } from '../PasteOrConnectWalletModal';

interface ReceivingWalletLineCrossChainModeProps {
  chainId: number;
  connectedWalletAddress: string | undefined;
}

export const ReceivingWalletLineCrossChainMode = ({
  chainId,
  connectedWalletAddress,
}: ReceivingWalletLineCrossChainModeProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { pastedReceivingWalletAddress } = useMarketTradeSettingsStore(
    pastedReceivingWalletAddressSelector,
  );

  const displayAddress = pastedReceivingWalletAddress ?? connectedWalletAddress;
  const isSendingToSelf = !pastedReceivingWalletAddress;

  return (
    <button
      type="button"
      className="flex items-center justify-between w-auto grow-1 -mx-3 px-3 py-1.5 min-h-9 rounded-sm transition-colors duration-[150ms] ease-in-out hover:cursor-pointer hover:bg-token-alphalight-200"
      onClick={() => setIsModalOpen(true)}
      aria-label="Edit receiving wallet"
    >
      <div
        className={fontStyles({
          variant: 'BODY_MD',
          class: 'flex items-center text-token-gray-800',
        })}
      >
        Receiving wallet
      </div>
      <div className="relative flex items-center gap-1">
        <span
          className={fontStyles({
            variant: 'BODY_MD',
            class: 'text-token-gray-800',
          })}
        >
          {isSendingToSelf ? 'Connected' : 'Custom'}
        </span>
        <span className="text-token-gray-800 text-350">·</span>
        <span
          className={fontStyles({
            variant: 'BODY_MD',
            class: 'text-token-gray-1600',
          })}
        >
          {displayAddress ? formatShortAddress(displayAddress) : '—'}
        </span>

        <EditIcon className="size-4 text-token-gray-800 ml-0.5" aria-hidden />
        <PasteOrConnectWalletModal
          isOpen={isModalOpen}
          onOpenChange={setIsModalOpen}
          onClose={() => setIsModalOpen(false)}
          chainId={chainId}
          popoverClass="bg-special-background-modal absolute h-auto rounded-[1.125rem] z-100 shadow-25 bottom-11 right-0 w-[344px]"
        />
      </div>
    </button>
  );
};
